import { Injectable, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, filter, tap } from 'rxjs';
import {
  NavigationItem,
  RoutePath,
} from '../interfaces/navigationList.interface';
import { FiltersLocation } from '../interfaces/region.interface';
import {
  HomeButtonConfig,
  Profile,
} from '../interfaces/PageContainerConfiguration.interface';

@Injectable({
  providedIn: 'root',
})
export class PageContainerService {
  private navigationList: NavigationItem[] = [];
  private routePath: RoutePath[] = [];
  activeSectionRoute = new BehaviorSubject<NavigationItem | null>(null);
  menuExpanded = new BehaviorSubject<boolean>(false);
  resetRouting$ = new BehaviorSubject<any>(null);
  changeTab$ = new BehaviorSubject<NavigationItem | null>(null);
  selectLastChild$ = new BehaviorSubject<NavigationItem | null>(null);
  selectedLocations$ = new BehaviorSubject<FiltersLocation[]>([]);

  expandMenuDrawer$ = new BehaviorSubject<boolean>(false);
  expandFilterDrawer$ = new BehaviorSubject<boolean>(false);

  homePageConfig = signal<HomeButtonConfig | null>(null);
  profileConfig = signal<Profile | null>(null);
  standAlonePageTitle = signal<string | null>(null);

  routerEvent$ = this.router.events.pipe(
    filter(event => event instanceof NavigationEnd),
    tap(event => {
      this.getActiveRoute(event);
    }),
  );

  constructor(readonly router: Router) {}

  initializeRouterEvent() {
    this.routerEvent$.subscribe();
  }

  setNavigationList(navigationList: NavigationItem[]) {
    this.navigationList = navigationList;
  }

  getNavigationList(): NavigationItem[] {
    return this.navigationList;
  }

  setRoutePath(routePath: RoutePath[]) {
    this.routePath = routePath;
  }

  getRoutePath(): RoutePath[] {
    return this.routePath;
  }

  private getActiveRoute(event: NavigationEnd) {
    this.resetRouting$.next(null);
    this.resetRouting();

    const cleanUrl = event.urlAfterRedirects.split('?')[0];

    const currentRoutePath = this.routePath.find(
      x => x.url === cleanUrl,
    )?.routePath;
    if (currentRoutePath) {
      const index = this.navigationList.findIndex(
        x => x.id === currentRoutePath[0],
      );
      if (index === -1) {
        throw new Error('Route id not found');
      }
      this.activeSectionRoute.next(this.navigationList[index]);
      this.standAlonePageTitle.set(this.navigationList[index].name);
    } else if (cleanUrl === this.homePageConfig()?.routeUrl) {
      this.standAlonePageTitle.set(this.homePageConfig()?.title ?? null);
    } else if (cleanUrl === this.profileConfig()?.profileRoute) {
      this.standAlonePageTitle.set(this.profileConfig()?.title ?? null);
    } else {
      this.standAlonePageTitle.set(null);
    }
  }

  handleInitialNavigation(url: string) {
    this.getActiveRoute({ urlAfterRedirects: url } as NavigationEnd);
  }

  resetRouting() {
    this.activeSectionRoute.next(null);
    this.resetRouting$.next(null);
  }
}
